function _fixCustomSelect(select) {
	const selectedIndex = Math.max(0, select.selectedIndex);
	const iconElement = select.menu_
		.getOptionByIndex(selectedIndex)
		.querySelector('[data-select="optionIcon"]');

	if (iconElement) {
		const icon = iconElement.innerText.trim();
		const iconColor = iconElement.style.color;

		if (iconColor) {
			const selectedIcon = select.root_.querySelector('[data-select="selectedIcon"]');

			if (selectedIcon) {
				selectedIcon.style.color = iconColor;
			}
		}

		select.leadingIconContent = icon;
		select.selectedText_.innerText = select.selectedText_.innerText.replace(icon, '').trim();
	}

	// There is no `open` event so we want to at least fix the size on change in addition to the initial setup
	// Alternatively, we could attach a window resize event listener
	select.menuElement_.style.width = `${select.root_.offsetWidth}px`;
}

function fixCustomSelect(select) {
	if (!select.menuElement_) {
		return;
	}

	_fixCustomSelect(select);

	select.listen('MDCSelect:change', () => {
		_fixCustomSelect(select);
	});

	select.root_.addEventListener('LN:updateFieldVisibility', () => {
		_fixCustomSelect(select);
	});
}

export { fixCustomSelect };
